function blobToArrayBuffer(blob)
{
    return new Uint8Array(blob);
}



export function getHeaderZFile(blob)
{


    
    
    const dataView = new DataView(blob.buffer);

    // Lire les 4 premiers octets comme un entier non signé 32 bits (DWORD)
    const HeaderSize = dataView.getUint16(0, true); // true pour little-endian
    const Version = dataView.getInt32(4, true); // true pour little-endian

    // le time code
    const subArray = blob.slice(8, 30); // en fait 12 chrs wchar_t soit 24
    const decoder = new TextDecoder('utf-16');
    const timecode = decoder.decode(subArray);    


    const ImageRef = dataView.getInt32(32, true); // true pour little-endian
    const frameRate = dataView.getUint32(36, true); // true pour little-endian
    const dropFrame = dataView.getUint32(40, true); // true pour little-endian
    const iFormatImage = dataView.getInt32(44, true); // true pour little-endian
    const NbCP = dataView.getInt32(48, true); // true pour little-endian
    const AudioAndVideo = dataView.getInt32(52, true); // true pour little-endian

    const durationSecond = dataView.getFloat32(56, true); // true pour little-endian
    const NbShotMax = dataView.getInt32(60, true); // true pour little-endian
    const AudioDataSize = dataView.getInt32(64, true); // true pour little-endian
    const nbSon = dataView.getInt32(68, true); // true pour little-endian
    const posDetection = dataView.getInt32(72, true); // true pour little-endian



    var header = {
        headerSize: HeaderSize,
        version: Version,
        timecode: timecode,
        imageRef: ImageRef,
        framerate: frameRate,
        dropFrame: dropFrame,
        iformatImage: iFormatImage,
        nbCP: NbCP,
        audioAndVideo: AudioAndVideo,
        durationSecond: durationSecond,
        nbShotMax: NbShotMax,
        audioDataSize: AudioDataSize,
        nbSon: nbSon,
        posDetection: posDetection,
        
        

    }

    //console.log(header);
    return header;

}